import { useTranslations } from 'next-intl';
import PlaylistTracklist from './PlaylistTracklist';
import PlaylistFAQs from './PlaylistFAQs';
import PlaylistFeatures from './PlaylistFeatures';
import RelatedArtists from './RelatedArtists';
import RelatedGenres from './RelatedGenres';
import RelatedTags from './RelatedTags';
import type { PlaylistContentData } from '@/lib/data/loaders/mongodb/playlists';

interface PlaylistContentProps {
  playlistContent: PlaylistContentData;
}

const PlaylistContent = ({ playlistContent }: PlaylistContentProps) => {
  const t = useTranslations('common');

  // Extract data from playlistContent
  const artists = playlistContent.artists || [];
  const genres = playlistContent.genres || [];
  const tags = playlistContent.tags || [];
  const featuredAccounts = playlistContent.featuredAccounts || [];

  return (
    <div className="col-md-8" data-testid="playlist-main-content">
      {/* Tracklist */}
      <div data-testid="playlist-tracklist-section">
        <PlaylistTracklist playlistContent={playlistContent} />
      </div>
      
      {/* Body Content */}
      <div data-testid="playlist-content-sections">
        {playlistContent.content_sections.map((section, index) => (
          <div
            key={index}
            className="mt-2"
            dangerouslySetInnerHTML={{ __html: section.content }}
            data-testid={`content-section-${index}`}
          />
        ))}
      </div>

      {/* Playlist Features */}
      {featuredAccounts.length > 0 && (
        <div data-testid="playlist-features-section">
          <PlaylistFeatures featuredAccounts={featuredAccounts} />
        </div>
      )}

      {/* Related Artists */}
      {artists.length > 0 && (
        <div data-testid="related-artists-section">
          <RelatedArtists artists={artists} />
        </div>
      )}

      {/* Related Genres */}
      {genres.length > 0 && (
        <div data-testid="related-genres-section">
          <RelatedGenres genres={genres} />
        </div>
      )}

      {/* Related Tags */}
      {tags.length > 0 && (
        <div data-testid="related-tags-section">
          <RelatedTags tags={tags} />
        </div>
      )}

      {/* Frequently Asked Questions */}
      <div data-testid="playlist-faqs-section">
        <PlaylistFAQs playlistContent={playlistContent} />
      </div>
    </div>
  );
};

export default PlaylistContent; 